import { useRef, useState } from 'react';
import ScrollImage from './_parts/ScrollImage/ScrollImage';
import ScrollLine from './_parts/ScrollLine/ScrollLine';
import { Wrapper } from './ScrollGallery.style';

// 1483 1593

export type ScrollGalleryProps = {
  items: any[];
  isLoading: boolean;
  onOpen: (item: Json) => void;
  onChange: (item: Json) => void;
};

export function ScrollGallery(props: ScrollGalleryProps) {
  const { isLoading, items } = props;
  const ref = useRef<HTMLDivElement>(null);
  const [item, setCurrentItem] = useState<any>(items[0]);

  function onClick(item: Json) {
    setCurrentItem(item);
    props.onChange(item);
  }

  return (
    <Wrapper className='ScrollGallery-wrapper' data-testid='ScrollGallery-wrapper' ref={ref}>
      <ScrollImage isDisabled={isLoading} item={item} onOpen={props.onOpen} />
      <ScrollLine item={item} onClick={onClick} {...props} />
    </Wrapper>
  );
}

export default ScrollGallery;
